export const DEFAULT_CLEAR_SELECTED_MESSAGE = 'Clear selected items';
